
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


export default {
name: 'GuideService',
components: {
Flexbox,
FlexboxItem
},
computed:{
template(){
return this.$route.meta.template;
}
},
methods: {
guide() {
let path = this.$route.path;
let orgUid = this.$route.params.orgUid;
this.$router.push({path: `/${this.template}/symptom/${orgUid}`, query: {source: path}});
}
}
}



// WEBPACK FOOTER //
// ./src/components/GuideService.vue